import { API_CONST } from "@/api/api.js"
export default {
    pluginRequestID: 0,
    socket: null,
    inFile: "",
    sealBack: null, //签章保存的回调函数 ，sealBack的func赋值在showSecSign.vue，所以如果为空就说明没有关闭webSocket的操作。
    vue_me: {},
    base64File: "",
    hideFun: null,
    // wiondows.onload
    onload: function(vue_me,isViewSeal) {
        if(isViewSeal || isViewSeal == undefined){
            this.vue_me = vue_me;
            this.connect();
        }
    },
    isHidden:function(hideFun){
        this.hideFun = hideFun;
    },
    connect: function() {
        let me = this;
        if (this.socket != null) {
            me.vue_me.$notify({
                message: "实时通信已经连接！",
                type: "info",
                offset: document.body.clientHeight - 200,
                duration: 2000, //设置为0则不自动关闭
            });
            return true;
        }
        //console.log(this.socket)
        let host = "ws://127.0.0.1:31213/";
        // try {
        this.socket = new WebSocket(host);
        // } catch (ex) {
        //     this.vue_me.$alert("您的IE版本较低无法进行签章操作，请更新至IE10及其以上或使用谷歌浏览器、360浏览器的“极速模式”。", "错误", {
        //         confirmButtonText: "确定",
        //         type: "error"
        //     })
        // }
        try {
            this.socket.onopen = function(msg) {
                me.vue_me.$notify({
                    message: "实时通信连接成功，可以打开签章文件。",
                    type: "info",
                    offset: document.body.clientHeight - 200,
                    duration: 2000, //设置为0则不自动关闭
                });
                // me.onSeal();
            };

            this.socket.onmessage = function(msg) {
                console.log(msg)
                    // 签章保存的回调
                if (typeof msg.data == "string") {
                    let resp = JSON.parse(msg.data);
                    let responseValue = resp.PluginResponseValue;
                    let pluginResponse = resp.PluginResponse;
                    // totalLen=373976,num=2,cur=1,AllSignaCount=1,SealCount=1,HandSignCount=0,MaxPage=2,Versions=60006
                    let str = pluginResponse.split(",");
                    // console.log(str)

                    let AllSignaCount = (str[3] == null || str[3] == "") ? null : parseInt(str[3].split("=")[1]);
                    let SealCount = str[4] == null ? null : parseInt(str[4].split("=")[1]);
                    let HandSignCount = str[5] == null ? null : parseInt(str[5].split("=")[1]);
                    let MaxPage = str[6] == null ? null : parseInt(str[6].split("=")[1]);
                    let Versions = str[7] == null ? null : parseInt(str[7].split("=")[1]);
                    console.log("总个数：" + AllSignaCount + "。其中印章个数：" + SealCount + "，签批个数：" + HandSignCount + "，总页数：" + MaxPage + "，版本号：" + Versions);
                    // if (AllSignaCount != null) {
                    //     if (AllSignaCount > 0 && SealCount < 2) {
                    //         me.vue_me.$alert("印章个数为" + SealCount + "必须是3个已经以上", "错误", {
                    //             confirmButtonText: "确定",
                    //             type: "error"
                    //         })
                    //         return;
                    //     }
                    // }

                    if (str[0].split("=")[1] > 0) {
                        let total = parseInt(str[1].split("=")[1]);
                        let cur = parseInt(str[2].split("=")[1]);
                        if (cur <= total) {
                            me.base64File += responseValue;
                        }
                        if (cur == total) {
                            if (me.sealBack != null) {
                                me.sealBack(msg.data, me.base64File);
                                me.base64File = "";
                            }
                        }
                    } else if (str[0].split("=")[1] == 0) {
                        // 没有返回东西 退出
                        if (me.sealBack != null) {
                            me.sealBack(msg.data, "");
                            me.base64File = "";
                        }
                    }
                } else {
                    me.vue_me.$alert("非文本消息", "错误", {
                        confirmButtonText: "确定",
                        type: "error"
                    })
                }
            };

            // this.socket.onmessage = function(msg) {
            //     // 签章保存的回调
            //     if (typeof msg.data == "string") {
            //         if (me.sealBack != null) {
            //             me.sealBack(msg.data, me.base64File);
            //         }
            //     } else {
            //         me.vue_me.$alert("非文本消息", "错误", {
            //             confirmButtonText: "确定",
            //             type: "error"
            //         })
            //     }
            // };
            this.socket.onclose = function(msg) {
                console.log("实时通信已经关闭。")
                    // me.vue_me.$notify({
                    //     message: "实时通信已经关闭。",
                    //     type: "info",
                    //     offset: document.body.clientHeight - 200,
                    //     duration: 2000,
                    //     //设置为0则不自动关闭
                    // });
            };
            this.socket.onerror = function(msg) {
                console.log("错误信息：", msg)
                    // SCRIPT12002: WebSocket Error: Network Error 12002, 操作超时
                if (typeof msg == "string" && msg.indexOf("SCRIPT12002") > -1) {

                } else {
                    me.vue_me.$alert('签章控件启动失败，可能是您的控件版本过旧或已安装的控件损坏，为避免影响正常使用，请前往首页下载并安装“凯特信安电子盖章软件', '', {
                        confirmButtonText: '确定',
                        type: "error"
                    });
                }
            };
        } catch (ex) {
            me.vue_me.$notify({
                title: "错误",
                message: "错误信息:" + ex.message,
                type: "erroe",
                offset: document.body.clientHeight - 200,
                duration: 2000, //设置为0则不自动关闭
            });
            return false;
        }
        return true;
    },
    //手动盖章
    /*
     *inFile：文件的地址，可以是绝对路径，也可以是http地址
     *
     *
     *
     */
    onSeal: function(inFile) {
        // console.log("inFile=" + inFile)
        console.log("onSeal")
        this.pluginRequestID++;
        // 增加json字段中屏蔽功能字段。例如“ShieldFun”：“12” -》“1”代表屏蔽盖章 “2”代表屏蔽批量盖章  “12” 两个一起屏蔽
        let req = {};
        if (this.hideFun) {
            req = { "PluginRequestID": this.pluginRequestID, "ShieldFun": "1", "PluginRequest": "Seal", "InFile": inFile, "OutFile": "000", "PDFCommand": 13, "SetEditPdf": false, "SetSealToolVis": false, "SetToolButtonVis": -2, "SetDocSignType": 1, "GetEDCB64": true, "AutoCloseDocument": true, "PutIsOpenVerifyCrl": false, "PutIsPrint": true, "PutIsExportBlack": true, "PutIsCento": true, "docType": "word", "nFType": 3 };
        } else {
            req = { "PluginRequestID": this.pluginRequestID, "PluginRequest": "Seal", "InFile": inFile, "OutFile": "000", "PDFCommand": 13, "SetEditPdf": false, "SetSealToolVis": false, "SetToolButtonVis": -2, "SetDocSignType": 1, "GetEDCB64": true, "AutoCloseDocument": true, "PutIsOpenVerifyCrl": false, "PutIsPrint": true, "PutIsExportBlack": true, "PutIsCento": true, "docType": "word", "nFType": 3 };
        }
        try {
            this.socket.send(JSON.stringify(req));
        } catch (error) {

        }
    },

    //查看签章
    viewSeal: function(url, isFromSupervisorEnd, isViewSeal) {
        // n = 0;
        // // temp = [];		 current\\hy_safety_unitselfeval\\2015\\08\\SecSeal_f59b07854eda5d55014ee22210c03b62SGXMKP001.edc
        let inFile = url;
        if (isFromSupervisorEnd) { //从监管的来的数据，要转换+头
            inFile = API_CONST.SupervisorSecSealURL + url.replace(/\\\\/g, "/");
        }
        if (url.indexOf("\\") > -1 && !url.startsWith("supervisorSecSeal")) {
            inFile = API_CONST.SupervisorSecSealURL + url.replace(/\\\\/g, "/");
        } else if (url.startsWith("current")) {
            inFile = API_CONST.SupervisorSecSealURL;
        } else if (!inFile.startsWith("http")) {
            inFile = this.getOssFileURL(url);
        }
        if (!inFile.startsWith("http")) {
            // console.log(inFile.startsWith("http"))
            this.vue_me.$alert("不是有效文档连接，建议重新盖章保存", "错误", {
                confirmButtonText: "确定",
                type: "error"
            })
            return;
        }
        console.log(inFile)
        if (typeof isViewSeal != "boolean" || isViewSeal == null || isViewSeal == true) {
            this.pluginRequestID++;
            // console.log("查看盖章地址 : " + inFile);
            let req = { "PluginRequestID": this.pluginRequestID, "PluginRequest": "Seal", "InFile": inFile, "OutFile": "000", "PDFCommand": 13, "SetEditPdf": false, "SetSealToolVis": false, "SetToolButtonVis": -2, "SetDocSignType": 1, "GetEDCB64": true, "AutoCloseDocument": true, "PutIsOpenVerifyCrl": false, "PutIsPrint": true, "PutIsExportBlack": true, "PutIsCento": true, "rightAllButton": 382 };
            this.socket.send(JSON.stringify(req));
        } else {
            window.open(inFile);
        }
    },
    // wiondows.onbeforeunload  在即将离开当前页面(刷新或关闭)时执行 JavaScript :
    onbeforeunload: function() {
        console.log("leave")
        if (this.socket == null)
            return;
        try {
            this.socket.close();
            this.socket = null;
        } catch (ex) {}
    },
    getOssFileURL: function(inFile) {
        let client = new OSS.Wrapper({
            region: 'oss-cn-hangzhou',
            //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
            accessKeyId: API_CONST.accessKeyId,
            accessKeySecret: API_CONST.accessKeySecret,
            bucket: API_CONST.bucketName
        });
        let suffix = inFile.substring(inFile.lastIndexOf(".") + 1, inFile.length);
        if (suffix == "dec") {
            suffix = "edc";
        }
        let fileName = inFile.substring(0, inFile.lastIndexOf("."));
        return client.signatureUrl(inFile, {
            response: {
                'content-disposition': 'attachment; filename="' + fileName + "." + suffix + '"'
            }
        });
    },
}



// WEBPACK FOOTER //
// ./src/tool/secSeal.js